@if (!formsDisabled) {
    <table
        class="table table-center table-add-row"
        [class.disabled]="formsDisabled"
        [class.table-last-col]="!formsDisabled">
        <tr>
            <th colspan="3">Type</th>
            <th>Ontvangst</th>
            @if (Functionalities.TransportplanningManagement | hasFunctionality) {
                <th>Machinist</th>
            }
            <th class="number-input" [matTooltip]="'cutter-tons' | tt">Ton</th>
            <th class="number-input">Dikte <small>mm</small></th>
            <th class="number-input" [matTooltip]="'trucks-count' | tt">Vrachtwagens</th>
            <th class="tabledate" [matTooltip]="'cutter-time' | tt">Datum</th>
            <th class="tabletime" [matTooltip]="'cutter-time' | tt">Tijdsblok</th>
            <th class="comment">Opmerking</th>
            @if (!formsDisabled) {
                <th></th>
            }
        </tr>

        @for (planning of planningEntitiesList; track planning) {
            @if (planningEntitiesForm.get(planning)) {
                <tr [formGroup]="planningEntitiesForm.get(planning)">
                    <td
                        class="cutter-selection"
                        [attr.colspan]="!planning.entity || planning.entity.use_once ? '3' : '1'"
                        [class.use-multiple]="planning.entity && !planning.entity.use_once"
                        [matTooltip]="planning?.entity?.name">
                        <div class="d-flex">
                            <mat-select formControlName="entity_id" placeholder="Frees" panelWidth="300px">
                                @for (cutter of entities; track cutter) {
                                    <mat-option
                                        [disabled]="
                                            cutter.notAvailable ||
                                            (cutter.use_once &&
                                                cutter.usedHere &&
                                                cutter.id !== planningEntitiesForm.get(planning).get('entity_id').value)
                                        "
                                        [matTooltip]="
                                            'cutter-na' +
                                                (cutter.notAvailable
                                                    ? '-na'
                                                    : cutter.usedHere &&
                                                        cutter.id !==
                                                            planningEntitiesForm.get(planning).get('entity_id').value
                                                      ? '-here'
                                                      : '') | tt
                                        "
                                        [value]="cutter.id">
                                        {{ cutter.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </div>
                    </td>
                    @if (planning.entity && !planning.entity.use_once) {
                        <td class="cutter-selection">
                            <div class="d-flex">
                                <mat-select formControlName="hiring_id" placeholder="Inhuur" panelWidth="200px">
                                    @for (hiring of hiringList; track hiring) {
                                        <mat-option [value]="hiring.id">
                                            {{ hiring.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </div>
                        </td>
                    }
                    @if (planning.entity && !planning.entity.use_once) {
                        <td class="text-input hire-name">
                            <input
                                class="row-input"
                                autocomplete="off"
                                formControlName="name"
                                placeholder="Naam"
                                type="text" />
                        </td>
                    }
                    <td class="text-input" [matTooltip]="planning?.location">
                        <input
                            class="row-input"
                            autocomplete="off"
                            formControlName="location"
                            placeholder="Locatie"
                            type="text" />
                    </td>
                    @if (Functionalities.TransportplanningManagement | hasFunctionality) {
                        <td
                            class="select driver ng-select-red"
                            [matTooltip]="
                                planning.driver_user_id
                                    ? (drivers | byId: planning.driver_user_id)?.name
                                    : planning?.driver
                            "
                            [class.red-error]="planningEntitiesForm.get(planning).get('driver_user_id').invalid">
                            <ng-select placeholder="Chauffeur" formControlName="driver_user_id">
                                @for (user of drivers; track user) {
                                    <ng-option [value]="user.id" [innerHTML]="user.name"></ng-option>
                                }
                            </ng-select>
                        </td>
                    }
                    <td class="number-input">
                        <input
                            class="row-input"
                            appDecimalInput
                            autocomplete="off"
                            formControlName="tons"
                            placeholder="0"
                            type="text" />
                    </td>
                    <td class="number-input">
                        <input
                            class="row-input"
                            appDecimalInput
                            autocomplete="off"
                            autocomplete="off"
                            formControlName="thickness"
                            placeholder="0"
                            type="text" />
                    </td>
                    <td
                        class="number-input"
                        [class.warning]="
                            +planning.trucks >
                            availableTrucks.get(planning) - maxUsedTrucks.get(planning) + (+planning.trucks || 0)
                        "
                        [matTooltip]="'trucks-count' | tt">
                        <div class="available-trucks">
                            {{ availableTrucks.get(planning) - maxUsedTrucks.get(planning) + (+planning.trucks || 0) }}
                        </div>
                        <input
                            class="row-input"
                            appDecimalInput
                            autocomplete="off"
                            formControlName="trucks"
                            placeholder="0"
                            type="text" />
                    </td>
                    <ng-container formGroupName="date">
                        <td class="tabledate">
                            <input
                                class="row-input"
                                [matDatepicker]="pickerStart"
                                [max]="mainPlanning.enddate"
                                [min]="minDatePicker"
                                (focus)="pickerStart.open()"
                                (click)="pickerStart.open()"
                                formControlName="date"
                                placeholder="Datum" />
                            <mat-datepicker #pickerStart></mat-datepicker>
                        </td>
                        <td
                            class="tabletime"
                            [class.error-background]="
                                planningEntitiesForm.get(planning).errors &&
                                planningEntitiesForm.get(planning).errors.notAvailable
                            "
                            [matTooltip]="
                                'cutter-time' +
                                    (planningEntitiesForm.get(planning).get('entity_id').value ? '' : '-disabled') | tt
                            ">
                            <div class="timepicker">
                                <mat-select formControlName="begintime" placeholder="van" panelWidth="200px">
                                    <mat-select-trigger>
                                        <small>{{ planning.begindate | date: 'EEE' }}</small>
                                        {{ planning.begindate | date: 'HH:mm' }}
                                    </mat-select-trigger>
                                    @if (planningEntitiesForm.get(planning).get('entity_id').value) {
                                        @for (day of startTimesEntity.get(planning); track day) {
                                            <mat-optgroup label="{{ day.datetime | date: 'EEEE d MMM' }}">
                                                @for (time of day.options; track time) {
                                                    <mat-option [disabled]="time.notAvailable" [value]="time.time">
                                                        {{ time.datetime | date: 'HH:mm' }}
                                                        <small>{{ time.datetime | date: 'EEE d MMM' }}</small>
                                                    </mat-option>
                                                }
                                            </mat-optgroup>
                                        }
                                    }
                                </mat-select>
                                <span>-</span>
                                <mat-select formControlName="endtime" placeholder="tot" panelWidth="200px">
                                    <mat-select-trigger>
                                        <small>{{ planning.enddate | date: 'EEE' }}</small>
                                        {{ planning.enddate | date: 'HH:mm' }}
                                    </mat-select-trigger>
                                    @if (endTimesEntity.has(planning)) {
                                        @for (day of endTimesEntity.get(planning); track day) {
                                            <mat-optgroup label="{{ day.datetime | date: 'EEEE d MMM' }}">
                                                @for (time of day.options; track time) {
                                                    <mat-option [disabled]="time.notAvailable" [value]="time.time">
                                                        {{ time.datetime | date: 'HH:mm' }}
                                                        <small>{{ time.datetime | date: 'EEE d MMM' }}</small>
                                                    </mat-option>
                                                }
                                            </mat-optgroup>
                                        }
                                    }
                                </mat-select>
                            </div>
                        </td>
                    </ng-container>
                    <td class="text-input" [matTooltip]="planning?.comment">
                        <input
                            class="row-input"
                            autocomplete="off"
                            formControlName="comment"
                            maxlength="300"
                            placeholder="Opmerking"
                            type="text" />
                    </td>
                    @if (!formsDisabled) {
                        <td>
                            <button
                                class="icon-button-medium"
                                (click)="removeEntityPlanning(planning)"
                                color="warn"
                                mat-icon-button
                                matTooltip="Verwijder"
                                matTooltipClass="warn-background"
                                matTooltipPosition="right"
                                tabindex="-1">
                                <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                            </button>
                        </td>
                    }
                </tr>
            }
        }
        <tr [hidden]="formsDisabled">
            <td [colSpan]="(Functionalities.TransportplanningManagement | hasFunctionality) ? 11 : 10">
                @if (!addButtonDisabled) {
                    <button class="w-100" (click)="addEntityPlanning()" color="primary" mat-button>
                        Frees toevoegen <i class="fas fa-plus"></i>
                    </button>
                }
                @if (addButtonDisabled) {
                    <div class="p-2" [class.warn-color]="warnIconLightUp">
                        <i class="fas fa-exclamation-triangle"></i> Er zijn geen frezen beschikbaar
                    </div>
                }
            </td>
            <td></td>
        </tr>
    </table>
}
@if (formsDisabled) {
    <table class="table table-center">
        <tr>
            <th>Type</th>
            <th>Ontvangst</th>
            <th>Machinist</th>
            <th class="number-input">Ton</th>
            <th class="number-input">Dikte <small>mm</small></th>
            <th class="number-input">Vrachtwagens</th>
            <th>Datum</th>
            <th class="tabletime">Tijdsblok</th>
            <th>Opmerking</th>
        </tr>
        @for (cutter of planning.planning_cutters; track cutter) {
            <tr>
                @if ((entities | byId: cutter.entity_id)?.use_once) {
                    <td>
                        {{ (entities | byId: cutter.entity_id)?.name }}
                    </td>
                } @else if (!(entities | byId: cutter.entity_id)?.use_once) {
                    <td>
                        {{ cutter.name }}
                    </td>
                }
                <td>{{ cutter.location }}</td>
                <td>{{ cutter.driver }}</td>
                <td>{{ cutter.tons }}</td>
                <td>{{ cutter.thickness }}</td>
                <td>{{ cutter.trucks }}</td>
                <td>{{ cutter.begindate | date: 'EEE dd MMM' }}</td>
                <td>{{ cutter.begindate | date: 'H:mm' }} - {{ cutter.enddate | date: 'H:mm' }}</td>
                <td>{{ cutter.comment }}</td>
            </tr>
        }
    </table>
}
